import StateObserver from 'src/StateObserver';
import { duration } from 'src/replicant/utils/duration';
import i18n from 'src/lib/i18n/i18n';
import * as Social from 'src/replicant/social';
import { LockedStatus } from '../components/footer/footer.utils';
import * as Visit from 'src/replicant/visit';

export function getTimestampText(time: number) {
  const now = StateObserver.now();
  const durationSinceTime = now - time;
  if (durationSinceTime < duration({ hours: 1 })) {
    return i18n('friendsVisit.popup.timestamp.justNow');
  }

  const today = new Date(now);
  today.setHours(0, 0, 0, 0);
  const timestampDay = new Date(time);
  timestampDay.setHours(0, 0, 0, 0);
  const daysSinceLastLogin =
    (today.getTime() - timestampDay.getTime()) / duration({ days: 1 });
  if (daysSinceLastLogin < 1) {
    return i18n('friendsVisit.popup.timestamp.today');
  }
  if (daysSinceLastLogin < 2) {
    return i18n('friendsVisit.popup.timestamp.yesterday');
  }
  if (daysSinceLastLogin < 7) {
    return i18n('friendsVisit.popup.timestamp.nDaysAgo', {
      days: Math.round(daysSinceLastLogin),
    });
  }
  return i18n('friendsVisit.popup.timestamp.moreThanAWeekAgo');
}

/**
 * Get the locked status of the friends menu.
 * @returns
 */
export function getFriendsMenuLocked(): LockedStatus {
  const { ui, user } = StateObserver.getState();

  if (
    !Social.getters.isFriendInviteAvailable(user) &&
    !Visit.getters.isUnlocked(user)
  ) {
    return { locked: true };
  }

  if (ui.transition.nextScene === 'friendsLivingRoom') {
    return { locked: true, reason: 'visitingFriend' };
  }

  return { locked: false, reason: undefined };
}
